import { Controller } from '@hotwired/stimulus'

// Initializes the jQuery UI datepicker inside the IV historical market rates modal.
export default class extends Controller {
  static targets = ['hiddenInput']
  static values = { vesselType: String }

  connect() {
    const minDate = this.vesselTypeValue === 'capesize' ? new Date(2025, 10, 1) : new Date(2023, 7, 5)

    $(this.element).datepicker({
      dateFormat: 'dd-mm-yy',
      updateViewDate: true,
      changeMonth: true,
      changeYear: true,
      defaultDate: this.hasHiddenInputTarget ? this.hiddenInputTarget.value : new Date(),
      minDate,
      maxDate: new Date(),
      onSelect: (date) => {
        if (this.hasHiddenInputTarget) this.hiddenInputTarget.value = date
        this.element.dispatchEvent(new CustomEvent('iv-datepicker:dateSelected', { bubbles: true, detail: { date } }))
      }
    })
  }
}
